import { Chip, ChipProps } from "@mui/material";
import React from "react";
import { TestExecutionStatus } from "@finvari/deliver";

export type TestStatusChipProps = ChipProps & {
  status: TestExecutionStatus | null | undefined
}

export default function TestStatusChip({ status, variant='outlined', ...chipProps }: TestStatusChipProps) {
  if (!status) {
    return <Chip label="not started" color="secondary" variant={variant} {...chipProps} />
  }
  return <Chip
    label={status.replace('_', ' ')}
    color={status === 'completed' ? 'success' : 'primary'}
    variant={variant}
    {...chipProps}
  />
}

